import { createApp } from 'vue'
import App from './apps/isigma-alerts-app/AlertsDialogApp.vue'

createApp(App).mount('#alerts-dialog-app')
